import Report from '@/components/analyses/Report';
import { useParams } from 'react-router';

const PathwayAnalysisRoute = () => {
  const { pathwayId } = useParams();
  return <Report key={pathwayId} />;
};

export default PathwayAnalysisRoute;
